import { render, staticRenderFns } from "./WaitForApprovalDetailComponent.vue?vue&type=template&id=74057176&scoped=true&"
import script from "./WaitForApprovalDetailComponent.vue?vue&type=script&lang=js&"
export * from "./WaitForApprovalDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./WaitForApprovalDetailComponent.vue?vue&type=style&index=0&id=74057176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74057176",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCardText,VCol,VRow,VSelect})
